import React from 'react'
import {useSelector} from 'react-redux'

const SubjectsInputs = ({formdata, handleStateChange}) => {
    const theoretical = useSelector(state => state.student.theoritical_subjects)
    const gradings = useSelector(state => state.student.grading_subjects)


    const theoreticalInputs =  theoretical && theoretical.map((el, index) => {
        return (
            <div key={index}>
                <label className='capitalize font-medium text-gray-800'>{el}</label>
                <input type="text" value={formdata[el]} 
                 onChange={(e) =>  handleStateChange(el, e.target.value)}
                 className="w-full p-2 border border-gray-300 rounded-md outline-none" />
            </div>
        )
    })
    const gradingsInputs = gradings && gradings.map((el, index) => {
        return (
            <div key={index}>
                <label className='capitalize font-medium text-gray-800'>{el.replace("_", " ")}</label>
                <select  onChange={e => handleStateChange(el, e.target.value)} value={formdata[el]}  className="p-3 text-gray-800 text-sm font-medium rounded-md bg-gray-100 w-full" >
                <option value="">Select Grade</option>
                    <option value="A1">A1</option>
                    <option value="A2">A2</option>
                    <option value="B1">B1</option>
                    <option value="B2">B2</option>
                    <option value="C1">C1</option>
                    <option value="C2">C2</option>
                    <option value="D">D</option>
                    <option value="E">E</option>
                </select>
            </div>
        )
    })
  return (
    <div>
      <div className='flex flex-wrap gap-4 justify-start items-center mb-6'>
        {theoreticalInputs}
        {gradingsInputs}
      </div>
    </div>
  )
}

export default SubjectsInputs
